import { SiteFooter } from '@/components/SiteFooter/SiteFooter';
import { SiteHeader } from '@/components/SiteHeader/SiteHeader';
import { NAV } from '@/dictionary/common';
import type { ReactNode } from 'react';
import classes from './PageLayout.module.css';

/** מזהה יעד הדילוג. משמש גם את הקישור וגם את תגית ה-main. */
const MAIN_CONTENT_ID = 'main-content';

interface PageLayoutProps {
  children: ReactNode;
  /** בעמוד הבית הכותרת נחשפת בגלילה בלבד */
  revealHeaderOnScroll?: boolean;
}

export function PageLayout({ children, revealHeaderOnScroll = false }: PageLayoutProps) {
  return (
    <>
      {/* מאפשר לגולשי מקלדת לדלג על תפריט הניווט בכל עמוד */}
      <a href={`#${MAIN_CONTENT_ID}`} className={classes.skipLink}>
        {NAV.skipToContent}
      </a>
      <SiteHeader alwaysVisible={!revealHeaderOnScroll} />
      <main id={MAIN_CONTENT_ID}>{children}</main>
      <SiteFooter />
    </>
  );
}
